<template>
  <div v-if="expirationText" class="default-expiration-display">
    <span class="expiration-value">{{ expirationText }}</span>
  </div>
  <div v-else class="default-expiration-display text-gray-400">
    <span>Select a member card to see default expiration</span>
  </div>
</template>

<script>
import { computed } from 'vue';

const unitLabels = {
  Months: { singular: 'month', plural: 'months' },
  Days: { singular: 'day', plural: 'days' },
  Weeks: { singular: 'week', plural: 'weeks' },
};

export default {
  name: 'DefaultExpirationDisplay',
  props: {
    field: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: null
    },
    context: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const expirationText = computed(() => {
      if (props.modelValue === null || props.modelValue === undefined) {
        return null;
      }
      if (props.modelValue === 0) {
        return 'Never expires';
      }
      const unit = props.context?.defaultExpirationUnit ?? "Months";
      const labels = unitLabels[unit] || unitLabels.Months;
      const label = props.modelValue === 1 ? labels.singular : labels.plural;
      return `${props.modelValue} ${label}`;
    });

    return {
      expirationText,
    };
  },
};
</script>

<style scoped>
.default-expiration-display {
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.95rem;
}

.expiration-value {
  color: #334155;
  font-weight: 500;
}
</style>
